class HeroSlideshowComponent extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const boot = () => this.initSwiper();
    if (window.Swiper) {
      boot();
    } else {
      window.addEventListener('load', boot, { once: true });
    }
  }

  initSwiper() {
    const loop = this.getAttribute('data-loop') === 'true';
    const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
    const delay = (parseFloat(this.getAttribute('data-speed')) || 5) * 1000;
    const paginationEnabled = this.getAttribute('data-pagination') === 'true';
    const slideCount = this.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loop && slideCount > 1,
      speed: 500,
      grabCursor: true,
      simulateTouch: true,
      autoHeight: false,
      autoplay:
        autoplayEnabled && slideCount > 1
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      pagination:
        paginationEnabled && slideCount > 1
          ? { el: this.querySelector('.swiper-pagination'), clickable: true }
          : false,
    });
  }
}

customElements.define('hero-slideshow-component', HeroSlideshowComponent);
